module.exports = __webpack_public_path__ + "img/item-7.308e437.png";